import React from 'react';
import { Language, translations } from '../utils/translations';
const heroImageUrl = 'https://cdn.magicpatterns.com/patterns/generated-images/e22061f7-97ea-4ef3-85fa-9d606a594a95.jpg';
export function Hero({
  lang
}: {
  lang: Language;
}) {
  const t = translations[lang];
  return <header className="px-1 pt-2 text-center" data-id="element-115" data-mp="4lyv8luf2edn">
      <h1 className="mx-auto max-w-[370px] text-[29px] font-extrabold leading-[1.08] tracking-[-0.055em] text-zinc-50" data-id="element-116" data-mp="4n9zsnvorq5t">
        {t.heroTitle}
      </h1>
      <p className="mx-auto mt-3 max-w-[340px] text-[13px] font-medium leading-relaxed text-zinc-400" data-id="element-117" data-mp="xanpc0x21jfw">
        {t.heroSubtitle}
      </p>

      <figure className="mt-6 overflow-hidden rounded-[24px] bg-zinc-900 text-left" data-id="element-118" data-mp="s9zxxe4wz0l5">
        <img src={heroImageUrl} alt={t.heroAlt} className="h-[200px] w-full object-cover object-center opacity-90 sm:h-[240px]" data-id="element-119" data-mp="nb6ktmtjhbli" />
      </figure>
    </header>;
}